const API_ENDPOINT = process.env.REACT_APP_API_GATEWAY_URL;

const SNOW_ENDPOINT = API_ENDPOINT + "/snow";
const EMAIL_ENDPOINT = API_ENDPOINT + "/email";
const LOGS_ENDPOINT = API_ENDPOINT + "/logs";
const ATTR_ENDPOINT = API_ENDPOINT + "/attributes";
const NOVA_ENDPOINT = API_ENDPOINT + "/nova";

export const generateSummary = async (ticketNumber, language) => {
    try {
        let response = await fetch(NOVA_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "ticket_number": ticketNumber,
                        "language": language
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking generateSummary:', error);
        throw error;
    }
};

export const getUserAttributes = async (username) => {
    try {
        let response = await fetch(ATTR_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "username": username
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking GetUserAttributes:', error);
        throw error;
    }
};

export const getIncidentData = async (case_number, employee_id) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetIncidentData",
                        "CaseNumber": case_number,
                        "EID": employee_id
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking GetIncidentData:', error);
        throw error;
    }
};

export const createIncident = async (configuration_item, category, subcategory, caller_email, reported_by, caller_phone_number, urgency, impact, short_description, full_description) => {
    try {
        const userEid = localStorage.getItem("user_eid") || "";
        const userEmail = localStorage.getItem("user_email") || "";
        const userIdentifier = localStorage.getItem("user_identifier") || "";

        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "CreateIncident", 
                        "Configuration_Item": configuration_item,
                        "Category": category, 
                        "Subcategory": subcategory, 
                        "Caller_Email": caller_email, 
                        "Reported_By": reported_by, 
                        "User_EID": userEid,
                        "User_Email": userEmail,
                        "User_Identifier": userIdentifier,
                        "Caller_Phone_Number": caller_phone_number, 
                        "Urgency": urgency, 
                        "Impact": impact, 
                        "ShortDescription": short_description, 
                        "FullDescription": full_description
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking CreateIncident:', error);
        throw error;
    }
};

export const addComment = async (case_number, sys_id, comment) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "AddComment", 
                        "CaseNumber": case_number, 
                        "SysID": sys_id,
                        "Comment": comment
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking AddComment:', error);
        throw error;
    }
}
export const validateAttachments = async (files) => {
  try {
    const response = await fetch(SNOW_ENDPOINT, {
      method: "POST",
      body: JSON.stringify({
        Details: {
          Parameters: {
            Action: "ValidateFiles",
            Files: files,
          },
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    
    if (response.status === 413) {
      return {
        Result: {
          result: (files || []).map((f) => ({
            Status: "Failure",
            Message: "Payload too large (HTTP 413). Please upload smaller files.",
            FileName: f?.filename || f?.FileName || "Unknown",
            ContentType: f?.content_type || f?.ContentType || "application/octet-stream",
          })),
        },
      };
    }

    
    if (!response.ok) {
      let text = "";
      try {
        text = await response.text();
      } catch (_) {}

      return {
        Result: {
          result: (files || []).map((f) => ({
            Status: "Failure",
            Message: `Validation request failed (HTTP ${response.status}). ${text || ""}`.trim(),
            FileName: f?.filename || f?.FileName || "Unknown",
            ContentType: f?.content_type || f?.ContentType || "application/octet-stream",
          })),
        },
      };
    }

    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error invoking validate attachment:", error);

    
    return {
      Result: {
        result: (files || []).map((f) => ({
          Status: "Failure",
          Message: "Validation request failed (network or client error).",
          FileName: f?.filename || f?.FileName || "Unknown",
          ContentType: f?.content_type || f?.ContentType || "application/octet-stream",
        })),
      },
    };
  }
};

export const getLocations = async(delegate, user, offset, limit) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetLocations",
                        "Delegate": delegate,
                        "User": user,
                        "Offset": offset,
                        "Limit": limit
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 
        
    } catch (error) {
        console.error('Error invoking getLocations:', error);
        throw error;
    }
}

export const getLocationData = async (location) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetLocationData",
                        "Location": location
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 
        
    } catch (error) {
        console.error('Error invoking getLocationData:', error);
        throw error;
    }
}

export const getLocationIncidents = async (location) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetLocationIncidents",
                        "Location": location
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 
        
    } catch (error) {
        console.error('Error invoking getLocationIncidents:', error);
        throw error;
    }
}

export const getKnowledgeCategories = async(language) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetKnowledgeCategories",
                        "Language": language
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 
        
    } catch (error) {
        console.error('Error invoking getKnowledgeCategories:', error);
        throw error;
    }
}

export const getKnowledgeArticles = async(category, language) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetKnowledgeArticles",
                        "Category": category,
                        "Language": language
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking getKnowledgeArticles:', error);
        throw error;
    }
}

export const getKnowledgeArticle = async(article, language) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetKnowledgeArticle",
                        "Article": article,
                        "Language": language
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking getKnowledgeArticle:', error);
        throw error;
    }
}

export const sendEmail = async(subject, body, addresses) => {
    try {
        let response = await fetch(EMAIL_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Subject": subject,
                        "Body": body,
                        "Addresses": addresses
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking sendEmail:', error);
        throw error;
    }
}

export const addAttachmentToIncident = async(incident, files) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "AddAttachmentToIncident",
                        "Incident": incident,
                        "Files": files
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking addAttachmentToIncident:', error);
        throw error;
    }
}

export const getAttachments = async(article, table) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetAttachments",
                        "Article": article,
                        "Table": table
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking getAttachments:', error);
        throw error;
    }
}

export const getAttachmentsRetry = async(article, attachment) => {
    try {
        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetAttachmentsRetry",
                        "Article": article,
                        "Attachment": attachment
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking getAttachmentsRetry:', error);
        throw error;
    }
}

export const getAnnouncements = async() => {
    try {
        const language = localStorage.getItem("language") === "fq" ? "FR" : "EN";

        let response = await fetch(SNOW_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Action": "GetAnnouncements",
                        "Language": language
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking getAnnouncements:', error);
        throw error;
    }   
}

export const updateDelegate = async (location, employeeId, notification) => {
  const payload = {
    Details: {
      Parameters: {
        Action: "UpdateDelegate",
        Location: location,
        EmployeeId: employeeId,
        Notification: notification
      }
    }
  };

  let response;
  try {
    response = await fetch(SNOW_ENDPOINT, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" }
    });
  } catch (networkErr) {
    console.error("updateDelegate network error:", networkErr);
    throw networkErr;
  }

  let parsed;
  const contentType = response.headers.get("content-type") || "";

  try {
    if (contentType.includes("application/json")) {
      parsed = await response.json();
    } else {
      const txt = await response.text();
      // intenta convertir "true"/"false"
      if (txt === "true") parsed = true;
      else if (txt === "false") parsed = false;
      else parsed = { raw: txt };
    }
  } catch (parseErr) {
    parsed = { raw: "Unable to parse response body" };
  }

  if (!response.ok) {
    const err = new Error(
      parsed?.error?.message ||
      parsed?.message ||
      `Request failed (${response.status})`
    );

    err.status = response.status;
    err.detail = parsed?.error?.detail || parsed?.detail || "";
    err.data = parsed;

    throw err;
  }

  return parsed;
};

export const logLogin = async(email, method) => {
    try {
        let response = await fetch(LOGS_ENDPOINT, {
            method: 'POST',
            body: JSON.stringify({
                "Details": {
                    "Parameters": {
                        "Email": email,
                        "Method": method
                    }
                }
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        let data = await response.json();
        return data; 

    } catch (error) {
        console.error('Error invoking logLogin:', error);
        throw error;
    }
}
